/* Mattress Overstock homepage motion, v0.1 (preview only, not installed on the live theme).
 * One seekable timeline per module: module.draw(ms). Play once when scrolled into view.
 * prefers-reduced-motion => each module jumps to its final frame and never animates.
 * No libraries. ~10 KB. */
(function () {
  'use strict';
  if (window.MOMotion) return; // theme sections may include this file more than once

  // ---------- easing + keyframe helpers ----------
  var E = {
    lin: function (x) { return x; },
    out: function (x) { return 1 - Math.pow(1 - x, 3); },
    in: function (x) { return x * x * x; },
    io: function (x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; },
    back: function (x) { var c = 1.9, d = c + 1; return 1 + d * Math.pow(x - 1, 3) + c * Math.pow(x - 1, 2); },
    slow: function (x) { return 1 - Math.pow(1 - x, 5); }
  };
  // kf(t, [[t0,v0],[t1,v1,'ease'],...]) -> value; ease on a key applies to the segment that ends there
  function kf(t, k) {
    if (t <= k[0][0]) return k[0][1];
    for (var i = 1; i < k.length; i++) {
      if (t <= k[i][0]) {
        var a = k[i - 1], b = k[i], p = (t - a[0]) / (b[0] - a[0]);
        return a[1] + (b[1] - a[1]) * (E[b[2] || 'io'])(p);
      }
    }
    return k[k.length - 1][1];
  }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  var SVGNS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (document.documentElement.hasAttribute('data-force-reduced')) reduced = true;

  // ---------- 1. MO mascot rig ----------
  var RIG = {
    'wave':       { w: 600, h: 600, pivot: [190, 246], eyes: [[265, 188, 22, 29], [349.5, 193.5, 23.5, 31.5]], lid: '#cf341a' },
    'point-left': { w: 600, h: 600, pivot: [210, 250], eyes: [[290.5, 172.5, 22.5, 32.5], [383, 176, 24, 33]], lid: '#cf3418' },
    'thumbs':     { w: 480, h: 600, pivot: [126, 272], eyes: [[193, 196.5, 20, 25.5], [265.5, 201.5, 21.5, 27.5]], lid: '#d1351a' }
  };
  var GESTURE = {
    'point-left': { rot: [[0, -38], [350, -38], [650, 7, 'back'], [820, -2], [920, 0]],
                    tx:  [[0, 0], [1080, 0], [1190, -11, 'out'], [1320, 0], [1440, -11, 'out'], [1580, 0]] },
    'wave':       { rot: [[0, 18], [300, 18], [560, -14, 'back'], [800, 10], [1040, -14], [1280, 10], [1520, -10], [1760, 0]] },
    'thumbs':     { rot: [[0, -50], [330, -50], [620, 9, 'back'], [780, -3], [880, 0]],
                    ty:  [[0, 0], [980, 0], [1080, -9, 'out'], [1220, 0]] }
  };
  function Mascot(root) {
    var pose = root.getAttribute('data-pose'), r = RIG[pose], base = root.getAttribute('data-src') || 'assets/';
    this.pose = pose; this.r = r; this.dur = 4200;
    root.classList.add('mo-rig');
    root.style.aspectRatio = r.w + ' / ' + r.h;
    var fig = document.createElement('div'); fig.className = 'mo-rig__fig';
    var arm = new Image(); arm.className = 'mo-rig__arm'; arm.alt = ''; arm.decoding = 'async';
    arm.src = root.getAttribute('data-arm') || base + 'mo-mascot-' + pose + '-arm.webp';
    var body = new Image(); body.className = 'mo-rig__body'; body.decoding = 'async';
    body.src = root.getAttribute('data-body') || base + 'mo-mascot-' + pose + '-body.webp';
    body.alt = root.getAttribute('data-alt') || '';
    arm.style.transformOrigin = (r.pivot[0] / r.w * 100) + '% ' + (r.pivot[1] / r.h * 100) + '%';
    var svg = el('svg', { viewBox: '0 0 ' + r.w + ' ' + r.h, class: 'mo-rig__fx', 'aria-hidden': 'true' });
    var defs = el('defs', {}, svg), lids = [];
    var uid = 'r' + Math.random().toString(36).slice(2, 7);
    r.eyes.forEach(function (e, i) {
      var cp = el('clipPath', { id: uid + i }, defs);
      el('ellipse', { cx: e[0], cy: e[1], rx: e[2] + 2, ry: e[3] + 2 }, cp);
      var g = el('g', { 'clip-path': 'url(#' + uid + i + ')' }, svg);
      var lid = el('rect', { x: e[0] - e[2] - 4, y: e[1] - e[3] - 4, width: e[2] * 2 + 8, height: e[3] * 2 + 8, fill: r.lid }, g);
      var arc = el('path', { d: 'M' + (e[0] - e[2] * .85) + ',' + e[1] + ' Q' + e[0] + ',' + (e[1] + e[3] * .55) + ' ' + (e[0] + e[2] * .85) + ',' + e[1],
        fill: 'none', stroke: '#2b1710', 'stroke-width': 6, 'stroke-linecap': 'round' }, svg);
      lids.push({ lid: lid, arc: arc, e: e });
    });
    // sparkle for thumbs-up (goldenrod = light, per brand system)
    var spark = null;
    if (pose === 'thumbs') {
      spark = el('g', { stroke: '#E5B800', 'stroke-width': 7, 'stroke-linecap': 'round' }, svg);
      [[-150, 34], [-100, 40], [-50, 34]].forEach(function (a) {
        var rad = a[0] * Math.PI / 180, x = 96, y = 172;
        el('line', { x1: x + Math.cos(rad) * 22, y1: y + Math.sin(rad) * 22, x2: x + Math.cos(rad) * (22 + a[1]), y2: y + Math.sin(rad) * (22 + a[1]) }, spark);
      });
      spark.style.transformOrigin = '96px 172px';
    }
    fig.appendChild(arm); fig.appendChild(body); fig.appendChild(svg);
    root.innerHTML = ''; root.appendChild(fig);
    this.fig = fig; this.arm = arm; this.lids = lids; this.spark = spark;
    var self = this;
    root.addEventListener('pointerenter', function () { self.ctl && self.ctl.replay(); });
    root.addEventListener('click', function () { self.ctl && self.ctl.replay(); });
  }
  Mascot.prototype.draw = function (t) {
    var g = GESTURE[this.pose], r = this.r;
    // enter: rise + mattress squash/stretch, origin at the feet
    var y = kf(t, [[0, 30], [260, -4, 'out'], [420, 0]]);
    var sy = kf(t, [[0, .9], [230, 1.05, 'out'], [400, .97], [520, 1]]);
    var sx = kf(t, [[0, 1.06], [230, .97, 'out'], [400, 1.02], [520, 1]]);
    var op = kf(t, [[0, 0], [160, 1, 'out']]);
    // tiny settle-bounce after each gesture beat
    this.fig.style.transform = 'translateY(' + y + '%) scale(' + sx + ',' + sy + ')';
    this.fig.style.opacity = op;
    var rot = kf(t, g.rot), tx = g.tx ? kf(t, g.tx) : 0, ty = g.ty ? kf(t, g.ty) : 0;
    this.arm.style.transform = 'translate(' + (tx / r.w * 100) + '%,' + (ty / r.h * 100) + '%) rotate(' + rot + 'deg)';
    // blinks at 1.7s and 3.4s
    var bl = Math.max(blink(t, 1700), blink(t, 3400));
    this.lids.forEach(function (L) {
      var e = L.e, h = (e[3] * 2 + 8);
      L.lid.setAttribute('height', (h * bl).toFixed(1));
      L.arc.style.opacity = bl > .92 ? 1 : 0;
    });
    if (this.spark) {
      var s = kf(t, [[0, 0], [860, 0], [1000, 1.15, 'out'], [1200, 1], [1500, 1], [1700, 0]]);
      this.spark.style.opacity = clamp(s, 0, 1);
      this.spark.style.transform = 'scale(' + (0.6 + .4 * s) + ')';
    }
  };
  function blink(t, at) { return kf(t, [[0, 0], [at, 0], [at + 70, 1, 'in'], [at + 110, 1], [at + 190, 0, 'out']]); }

  // ---------- 2. Mattress cutaways (memory foam / hybrid / innerspring), 2.5D ----------
  var BUILDS = {
    memory: {
      layers: [['Quilted cover', 9, '#f4efe8'], ['Memory foam', 32, '#e8cdb0'], ['Transition foam', 20, '#d8b999'], ['Support foam core', 46, '#c4a385']],
      press: { depth: 28, width: 42, p: 1.5, down: 1100, rec: 1700, recEase: 'slow', spring: 0 },
      caption: 'Slow sink. Slow return.'
    },
    hybrid: {
      layers: [['Quilted cover', 9, '#f4efe8'], ['Comfort foam', 22, '#e8cdb0'], ['Pocketed coils', 60, 'coils-pocket'], ['Base foam', 14, '#c4a385']],
      press: { depth: 22, width: 30, p: 1.0, down: 800, rec: 520, recEase: 'out', spring: 0 },
      caption: 'Foam on top. Coils push back.'
    },
    innerspring: {
      layers: [['Pillow top', 24, 'quilt'], ['Comfort pad', 8, '#e8cdb0'], ['Steel coil unit', 62, 'coils-open'], ['Base', 10, '#c4a385']],
      press: { depth: 18, width: 62, p: .75, down: 700, rec: 1000, recEase: 'lin', spring: 1 },
      caption: 'Quick, springy bounce.'
    }
  };
  var INK = '#2b1710';
  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = n >> 8 & 255, b = n & 255;
    function c(v) { return Math.round(f < 0 ? v * (1 + f) : v + (255 - v) * f); }
    return 'rgb(' + c(r) + ',' + c(g) + ',' + c(b) + ')';
  }
  function pts(a) { return a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join('L'); }
  function Cutaway(root) {
    var kind = root.getAttribute('data-build'), B = BUILDS[kind], self = this;
    this.B = B; this.kind = kind; this.dur = 6600;
    var W = 420, H = 258; this.W = W; this.H = H;
    this.mw = 236; this.bottom = 214; this.dx = 34; this.dy = 15;
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'mo-cut__svg', role: 'img', 'aria-label': kind + ' mattress layers' });
    this.svg = svg;
    var defs = el('defs', {}, svg), uid = 'c' + Math.random().toString(36).slice(2, 7);
    var rg = el('radialGradient', { id: uid + 'd' }, defs);
    el('stop', { offset: '0', 'stop-color': '#5b3a22', 'stop-opacity': .38 }, rg);
    el('stop', { offset: '1', 'stop-color': '#5b3a22', 'stop-opacity': 0 }, rg);
    var sg = el('radialGradient', { id: uid + 's' }, defs);
    el('stop', { offset: '0', 'stop-color': '#1b1c1d', 'stop-opacity': .28 }, sg);
    el('stop', { offset: '1', 'stop-color': '#1b1c1d', 'stop-opacity': 0 }, sg);
    this.floor = el('ellipse', { cy: 224, rx: 150, ry: 7, fill: '#1b1c1d', opacity: .08 }, svg);
    this.gM = el('g', {}, svg);
    this.total = B.layers.reduce(function (s, l) { return s + l[1]; }, 0);
    var acc = 0;
    this.L = B.layers.map(function (l, i) {
      var coil = l[2] === 'coils-pocket' || l[2] === 'coils-open';
      var base = l[2] === 'quilt' ? '#f4efe8' : coil ? (l[2] === 'coils-pocket' ? '#efe6da' : '#f3eee6') : l[2];
      var o = { name: l[0], th: l[1], kind: l[2], base: base, z0: acc / self.total, z1: (acc + l[1]) / self.total, i: i };
      acc += l[1];
      o.g = el('g', {}, self.gM);
      o.side = el('path', { fill: shade(base, -.16), stroke: INK, 'stroke-width': 2, 'stroke-linejoin': 'round' }, o.g);
      o.topf = el('path', { fill: shade(base, .35), stroke: INK, 'stroke-width': 2, 'stroke-linejoin': 'round' }, o.g);
      o.front = el('path', { fill: base, stroke: INK, 'stroke-width': 2.2, 'stroke-linejoin': 'round' }, o.g);
      if (coil) {
        o.coils = [];
        var n = l[2] === 'coils-pocket' ? 8 : 6;
        for (var c = 0; c < n; c++) {
          o.coils.push({
            pocket: l[2] === 'coils-pocket' ? el('rect', { fill: '#f8f2e9', stroke: '#c9b8a3', 'stroke-width': 1.3, rx: 7 }, o.g) : null,
            back: el('path', { fill: 'none', stroke: '#a89b8f', 'stroke-width': 1.6, 'stroke-linecap': 'round' }, o.g),
            front: el('path', { fill: 'none', stroke: '#5f5349', 'stroke-width': 2.3, 'stroke-linecap': 'round' }, o.g),
            f: (c + .5) / n
          });
        }
        if (l[2] === 'coils-open') {
          o.wireT = el('path', { fill: 'none', stroke: '#5f5349', 'stroke-width': 2.3 }, o.g);
          o.wireB = el('path', { fill: 'none', stroke: '#5f5349', 'stroke-width': 2.3 }, o.g);
        }
      }
      if (i === 0 || l[2] === 'quilt') {
        o.stitch = el('path', { fill: 'none', stroke: '#b9a58f', 'stroke-width': 1.2, 'stroke-dasharray': '4 4' }, o.g);
        o.tufts = [];
        for (var u = 1; u <= 4; u++) for (var v = 1; v <= 2; v++) o.tufts.push({ u: u / 5, v: v / 3, n: el('circle', { r: 1.8, fill: '#b9a58f' }, o.g) });
      }
      o.label = el('text', { 'font-size': 12.5, 'font-family': 'Inter, system-ui, sans-serif', 'font-weight': 500, fill: '#1b1c1d' }, svg);
      o.label.textContent = l[0];
      o.tick = el('line', { stroke: '#1b1c1d', 'stroke-width': 1, opacity: .45 }, svg);
      return o;
    });
    this.dent = el('ellipse', { fill: 'url(#' + uid + 'd)' }, svg);
    this.hshadow = el('ellipse', { fill: 'url(#' + uid + 's)' }, svg);
    // MO's arm + glove (same palette as the mascot)
    this.hand = el('g', {}, svg);
    el('path', { d: 'M-11,-330 L-11,-70 L11,-70 L11,-330', fill: '#cf3418', stroke: INK, 'stroke-width': 3 }, this.hand);
    el('rect', { x: -30, y: -78, width: 60, height: 20, rx: 9, fill: '#fbe8c8', stroke: INK, 'stroke-width': 3 }, this.hand);
    el('path', { d: 'M-24,-60 C-38,-58 -40,-30 -34,-14 C-31,-4 -24,-1 -19,-4 C-15,1 -8,2 -4,-2 C0,2 8,2 11,-2 C15,1 22,0 25,-5 C30,-10 36,-34 26,-60 Z',
      fill: '#fbe8c8', stroke: INK, 'stroke-width': 3, 'stroke-linejoin': 'round' }, this.hand);
    ['M-19,-5 C-20,-12 -19,-18 -18,-22', 'M-4,-3 C-5,-11 -4,-18 -3,-22', 'M11,-3 C10,-11 11,-18 12,-22'].forEach(function (d) {
      el('path', { d: d, fill: 'none', stroke: INK, 'stroke-width': 2.2, 'stroke-linecap': 'round' }, self.hand);
    });
    el('path', { d: 'M-20,-50 C-14,-54 -6,-55 2,-54', fill: 'none', stroke: '#fff', 'stroke-width': 3, 'stroke-linecap': 'round', opacity: .7 }, this.hand);
    this.cap = el('text', { x: 210, y: 250, 'text-anchor': 'middle', 'font-size': 14, 'font-family': 'Manrope, Inter, sans-serif', 'font-weight': 600, fill: '#1b1c1d' }, svg);
    this.cap.textContent = root.getAttribute('data-caption') || B.caption;
    if (root.clientWidth && root.clientWidth < 400) this.cap.setAttribute('font-size', 17);
    root.classList.add('mo-cut');
    root.insertBefore(svg, root.firstChild);
    root.addEventListener('pointerenter', function () { self.ctl && self.ctl.replay(); });
  }
  Cutaway.prototype.depress = function (t) {
    var P = this.B.press, A;
    var t0 = 2400, t1 = t0 + P.down, t2 = t1 + 450;
    if (t < t0) A = 0;
    else if (t < t1) A = E.io((t - t0) / P.down);
    else if (t < t2) A = 1;
    else if (P.spring) { var s = (t - t2) / 1000; A = s > 1.4 ? 0 : Math.exp(-4.2 * s) * Math.cos(11 * s); }
    else { var q = clamp((t - t2) / P.rec, 0, 1); A = 1 - E[P.recEase](q); }
    return { A: A * P.depth, lift: t >= t2 ? E.out(clamp((t - t2) / 380, 0, 1)) : 0 };
  };
  Cutaway.prototype.draw = function (t) {
    var B = this.B, P = B.press, self = this, mw = this.mw, bottom = this.bottom, DX = this.dx, DY = this.dy;
    var explode = kf(t, [[0, 1], [1300, 1], [2050, 0, 'io']]);
    var x0 = kf(t, [[0, 12], [1300, 12], [2050, (this.W - mw - DX) / 2, 'io']]);
    var hx = x0 + mw * .46, gap = 15 * explode;
    var A = this.depress(t).A, lift = this.depress(t).lift;
    function drop(x, z) { var d = (x - hx) / P.width; return A * Math.exp(-d * d) * Math.pow(1 - z, P.p); }
    var N = 40, xs = [];
    for (var i = 0; i <= N; i++) xs.push(x0 + mw * i / N);
    var nL = this.L.length, top = bottom - this.total - gap * (nL - 1), acc = 0;
    var labelCol = x0 + mw + DX + 12;
    this.floor.setAttribute('cx', x0 + (mw + DX) / 2);
    this.L.forEach(function (o, i) {
      var inT = kf(t, [[0, 0], [120 + i * 140, 0], [420 + i * 140, 1, 'out']]);
      var yTop = top + acc + gap * i - (1 - inT) * 24;
      acc += o.th;
      var yBot = yTop + o.th;
      o.g.style.opacity = inT;
      var tE = xs.map(function (x) { return [x, yTop + drop(x, o.z0)]; });
      var bE = xs.map(function (x) { return [x, yBot + drop(x, o.z1)]; });
      var front = 'M' + pts(tE) + 'L' + pts(bE.slice().reverse()) + 'Z';
      if (o.kind === 'quilt') {
        var q = 'M' + tE[0][0].toFixed(1) + ',' + (tE[0][1] + 5).toFixed(1), seg = 4;
        for (var k = 0; k < N; k += seg) {
          var a = tE[k], b = tE[Math.min(k + seg, N)];
          q += 'Q' + ((a[0] + b[0]) / 2).toFixed(1) + ',' + ((a[1] + b[1]) / 2 - 5).toFixed(1) + ' ' + b[0].toFixed(1) + ',' + (b[1] + 5).toFixed(1);
        }
        front = q + 'L' + pts(bE.slice().reverse()) + 'Z';
      }
      o.front.setAttribute('d', front);
      // right side face (unaffected by the dent: the press is centred)
      var xr = x0 + mw;
      o.side.setAttribute('d', 'M' + xr + ',' + yTop + 'L' + (xr + DX) + ',' + (yTop - DY) + 'L' + (xr + DX) + ',' + (yBot - DY) + 'L' + xr + ',' + yBot + 'Z');
      // top face: visible on every layer while exploded, only on the top layer once stacked
      var showTop = i === 0 ? 1 : explode;
      var back = tE.map(function (p) { return [p[0] + DX, yTop - DY + (p[1] - yTop) * .45]; });
      o.topf.setAttribute('d', 'M' + pts(tE) + 'L' + pts(back.slice().reverse()) + 'Z');
      o.topf.style.opacity = showTop;
      if (o.stitch) {
        var off = o.kind === 'quilt' ? o.th * .66 : o.th * .5;
        o.stitch.setAttribute('d', 'M' + pts(tE.map(function (p, j) { return [p[0], (p[1] + bE[j][1]) / 2 + (off - o.th / 2)]; })));
        o.tufts.forEach(function (tf) {
          var x = x0 + mw * tf.u, yy = yTop + drop(x, 0) * (1 - tf.v * .55);
          tf.n.setAttribute('cx', (x + DX * tf.v).toFixed(1)); tf.n.setAttribute('cy', (yy - DY * tf.v).toFixed(1));
          tf.n.style.opacity = showTop;
        });
      }
      if (o.coils) {
        o.coils.forEach(function (c) {
          var cx = x0 + mw * c.f, yt = yTop + drop(cx, o.z0) + 5, yb = yBot + drop(cx, o.z1) - 5, h = yb - yt;
          var turns = o.kind === 'coils-pocket' ? 7 : 6, w = o.kind === 'coils-pocket' ? 9 : 11, ry = Math.max(1.2, Math.min(3.2, h / turns * .45));
          if (c.pocket) { c.pocket.setAttribute('x', (cx - 13).toFixed(1)); c.pocket.setAttribute('y', (yt - 3).toFixed(1)); c.pocket.setAttribute('width', 26); c.pocket.setAttribute('height', (h + 6).toFixed(1)); }
          var fd = '', bd = '';
          for (var s = 0; s <= turns; s++) {
            var yy = yt + h * s / turns;
            var ww = o.kind === 'coils-open' ? w * (0.62 + 0.38 * Math.abs(2 * s / turns - 1)) : w;
            fd += 'M' + (cx - ww).toFixed(1) + ',' + yy.toFixed(1) + 'A' + ww.toFixed(1) + ',' + ry.toFixed(1) + ' 0 0 0 ' + (cx + ww).toFixed(1) + ',' + yy.toFixed(1);
            bd += 'M' + (cx - ww).toFixed(1) + ',' + yy.toFixed(1) + 'A' + ww.toFixed(1) + ',' + ry.toFixed(1) + ' 0 0 1 ' + (cx + ww).toFixed(1) + ',' + yy.toFixed(1);
            if (s < turns) {
              var y2 = yt + h * (s + 1) / turns, w2 = o.kind === 'coils-open' ? w * (0.62 + 0.38 * Math.abs(2 * (s + 1) / turns - 1)) : w;
              fd += 'M' + (cx + ww).toFixed(1) + ',' + yy.toFixed(1) + 'L' + (cx + w2).toFixed(1) + ',' + y2.toFixed(1);
            }
          }
          c.front.setAttribute('d', fd); c.back.setAttribute('d', bd);
        });
        if (o.wireT) {
          o.wireT.setAttribute('d', 'M' + pts(tE.map(function (p) { return [p[0], p[1] + 5]; })));
          o.wireB.setAttribute('d', 'M' + pts(bE.map(function (p) { return [p[0], p[1] - 5]; })));
        }
      }
      var ly = (yTop + yBot) / 2 - DY * .5;
      o.label.setAttribute('x', labelCol + 6); o.label.setAttribute('y', ly + 4.5);
      o.label.style.opacity = explode * inT;
      o.tick.setAttribute('x1', x0 + mw + DX + 2); o.tick.setAttribute('x2', labelCol + 2);
      o.tick.setAttribute('y1', ly); o.tick.setAttribute('y2', ly);
      o.tick.style.opacity = .45 * explode * inT;
    });
    // hand rides the top-face midline (a little back from the front edge)
    var hxx = hx + DX * .35, surf = top + drop(hx, 0) - DY * .35;
    var enter = kf(t, [[0, -170], [1950, -170], [2400, 0, 'out']]), up = lift * -150;
    var hy = surf + enter + up;
    this.hand.setAttribute('transform', 'translate(' + hxx.toFixed(1) + ',' + hy.toFixed(1) + ')');
    this.hand.style.opacity = t < 1950 ? 0 : 1;
    var gapH = clamp((surf - hy) / 150, 0, 1);
    this.hshadow.setAttribute('cx', hxx); this.hshadow.setAttribute('cy', surf - 2);
    this.hshadow.setAttribute('rx', 30 + 26 * gapH); this.hshadow.setAttribute('ry', 6 + 3 * gapH);
    this.hshadow.style.opacity = t < 1950 ? 0 : (1 - gapH) * .9;
    this.dent.setAttribute('cx', hxx); this.dent.setAttribute('cy', surf + 2);
    this.dent.setAttribute('rx', P.width * 1.3); this.dent.setAttribute('ry', 9);
    this.dent.style.opacity = clamp(A / P.depth, 0, 1);
    this.cap.style.opacity = kf(t, [[0, 0], [3000, 0], [3400, 1, 'out']]);
  };

  // ---------- 3. Promise icons (self-drawing line art) ----------
  function Icons(root) {
    this.paths = [].slice.call(root.querySelectorAll('svg [data-draw]'));
    this.paths.forEach(function (p) { p.setAttribute('pathLength', 1); p.style.strokeDasharray = '1 1'; });
    this.items = [].slice.call(root.querySelectorAll('[data-icon]'));
    this.dur = 2600;
  }
  Icons.prototype.draw = function (t) {
    this.items.forEach(function (it, i) {
      var st = i * 280;
      [].forEach.call(it.querySelectorAll('[data-draw]'), function (p, j) {
        var s = st + j * 160, v = kf(t, [[0, 1], [s, 1], [s + 700, 0, 'io']]);
        p.style.strokeDashoffset = v;
      });
      var acc = it.querySelector('[data-accent]');
      if (acc) { var a = kf(t, [[0, 0], [st + 700, 0], [st + 950, 1, 'back']]); acc.style.transform = 'scale(' + a + ')'; acc.style.opacity = clamp(a, 0, 1); }
      var txt = it.querySelector('[data-copy]');
      if (txt) { var c = kf(t, [[0, 0], [st + 200, 0], [st + 700, 1, 'out']]); txt.style.opacity = c; txt.style.transform = 'translateY(' + (1 - c) * 8 + 'px)'; }
    });
  };

  // ---------- 4. Kentucky showroom map ----------
  function KyMap(root, geo) {
    this.geo = geo; this.root = root; this.dur = 4600;
    var svg = el('svg', { class: 'mo-map__svg', preserveAspectRatio: 'none', 'aria-hidden': 'true' });
    this.svg = svg;
    this.counties = el('g', { fill: 'none', stroke: 'rgba(250,249,250,.14)', 'stroke-width': 1, 'vector-effect': 'non-scaling-stroke' }, svg);
    geo.counties.forEach(function (d) { el('path', { d: d, 'vector-effect': 'non-scaling-stroke' }, this.counties); }, this);
    this.fill = el('path', { d: geo.state, fill: 'rgba(250,249,250,.06)' }, svg);
    this.outline = el('path', { d: geo.state, fill: 'none', stroke: '#faf9fa', 'stroke-width': 2, 'vector-effect': 'non-scaling-stroke', pathLength: 1, 'stroke-linejoin': 'round' }, svg);
    this.outline.style.strokeDasharray = '1 1';
    root.appendChild(svg);
    var layer = document.createElement('div'); layer.className = 'mo-map__pins'; root.appendChild(layer);
    var sides = { Lexington: 'l', Georgetown: 'l', Richmond: 'r', London: 'r', Somerset: 'l' };
    // Theme: data-links = {"<town block label>": "<url>"}; only towns with a block get a pin.
    var links = null;
    try { links = JSON.parse(root.getAttribute('data-links') || 'null'); } catch (e) { links = null; }
    var pins = geo.pins.map(function (p) {
      if (!links) return p;
      for (var k in links) if (k.toLowerCase().indexOf(p.name.toLowerCase()) >= 0) return { name: p.name, x: p.x, y: p.y, href: links[k] || p.href };
      return null;
    }).filter(Boolean);
    geo = this.geo = { vw: geo.vw, vh: geo.vh, state: geo.state, counties: geo.counties, pins: pins.length ? pins : geo.pins };
    this.pins = geo.pins.map(function (p) {
      var a = document.createElement('a'); a.className = 'mo-pin mo-pin--' + sides[p.name]; a.href = p.href;
      a.innerHTML = '<span class="mo-pin__ring"></span><span class="mo-pin__dot"></span><span class="mo-pin__label">' + p.name + '</span>';
      layer.appendChild(a);
      return { p: p, a: a, ring: a.children[0], dot: a.children[1], label: a.children[2] };
    });
    var self = this;
    this.ro = new ResizeObserver(function () { self.layout(); self.draw(self.t || 0); });
    this.ro.observe(root);
    this.layout();
  }
  KyMap.prototype.layout = function () {
    var w = this.root.clientWidth || 1, h = this.root.clientHeight || 1, asp = w / h, g = this.geo;
    this.asp = asp;
    // full view: whole state; focus view: the five pins with margin
    var fw = g.vw * 1.04, fh = fw / asp; if (fh < g.vh * 1.08) { fh = g.vh * 1.08; fw = fh * asp; }
    this.full = [g.vw / 2 - fw / 2, g.vh / 2 - fh / 2, fw, fh];
    var xs = g.pins.map(function (p) { return p.x; }), ys = g.pins.map(function (p) { return p.y; });
    var cx = (Math.min.apply(0, xs) + Math.max.apply(0, xs)) / 2 + 8, cy = (Math.min.apply(0, ys) + Math.max.apply(0, ys)) / 2;
    var need = (Math.max.apply(0, ys) - Math.min.apply(0, ys)) + 250, nh = need, nw = nh * asp;
    var minW = (Math.max.apply(0, xs) - Math.min.apply(0, xs)) + 560; if (nw < minW) { nw = minW; nh = nw / asp; }
    this.focus = [cx - nw / 2, cy - nh / 2, nw, nh];
  };
  KyMap.prototype.draw = function (t) {
    this.t = t;
    var z = kf(t, [[0, 0], [1500, 0], [2600, 1, 'io']]);
    var vb = this.full.map(function (v, i) { return v + (this.focus[i] - v) * z; }, this);
    this.svg.setAttribute('viewBox', vb.map(function (v) { return v.toFixed(2); }).join(' '));
    this.outline.style.strokeDashoffset = kf(t, [[0, 1], [1400, 0, 'io']]);
    this.fill.style.opacity = kf(t, [[0, 0], [900, 0], [1500, 1]]);
    this.counties.style.opacity = kf(t, [[0, 0], [700, 0], [1500, 1]]);
    var W = this.root.clientWidth, H = this.root.clientHeight;
    this.pins.forEach(function (P, i) {
      var st = 2500 + i * 260;
      var x = (P.p.x - vb[0]) / vb[2] * W, y = (P.p.y - vb[1]) / vb[3] * H;
      var drop = kf(t, [[0, -60], [st, -60], [st + 380, 0, 'back']]);
      var op = kf(t, [[0, 0], [st, 0], [st + 120, 1]]);
      P.a.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      P.dot.style.transform = 'translate(-50%,-100%) translateY(' + drop + 'px)';
      P.a.style.opacity = op;
      var ring = kf(t, [[0, 0], [st + 380, 0], [st + 1300, 1, 'out']]);
      P.ring.style.transform = 'translate(-50%,-50%) scale(' + (0.3 + ring * 2.2) + ')';
      P.ring.style.opacity = ring > 0 && ring < 1 ? (1 - ring) * .8 : 0;
      P.label.style.opacity = kf(t, [[0, 0], [st + 250, 0], [st + 600, 1, 'out']]);
    });
  };

  // ---------- controller: play once in view, replay on demand, seek for export ----------
  var modules = [];
  function Ctl(m, node) {
    this.m = m; this.node = node; this.t0 = null; this.raf = 0; m.ctl = this; this.done = false;
    m.draw(reduced ? m.dur : 0);
  }
  Ctl.prototype.play = function () {
    if (reduced || window.MO_EXPORT) { this.m.draw(this.m.dur); return; }
    var self = this; cancelAnimationFrame(this.raf); this.t0 = null;
    function step(now) {
      if (self.t0 === null) self.t0 = now;
      var t = now - self.t0; self.m.draw(Math.min(t, self.m.dur));
      if (t < self.m.dur) self.raf = requestAnimationFrame(step); else self.done = true;
    }
    this.raf = requestAnimationFrame(step);
  };
  Ctl.prototype.replay = function () { if (this.raf && !this.done && this.t0 !== null && performance.now() - this.t0 < this.m.dur) return; this.done = false; this.play(); };

  var io = null;
  // Idempotent: only nodes not yet booted are built, so boot() may run again (theme editor reloads).
  function boot(opts) {
    opts = opts || {};
    var geo = opts.geo || window.MO_KY_GEO, fresh = [];
    function each(sel, make) {
      [].forEach.call(document.querySelectorAll(sel), function (n) {
        if (n.__mo) return;
        var m = make(n); if (!m) return;
        n.__mo = true; var c = new Ctl(m, n); modules.push(c); fresh.push(c);
      });
    }
    function safe(make) { return function (n) { try { return make(n); } catch (e) { if (window.console) console.warn('MOMotion', e); return null; } }; }
    each('[data-mo-mascot]', safe(function (n) { return new Mascot(n); }));
    each('[data-mo-cutaway]', safe(function (n) { return new Cutaway(n); }));
    each('[data-mo-icons]', safe(function (n) { return new Icons(n); }));
    each('[data-mo-map]', safe(function (n) { return geo ? new KyMap(n, geo) : null; }));
    if (window.MO_EXPORT) return;
    if (!io) io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var c = modules.filter(function (m) { return m.node === e.target; })[0];
        if (c && !c.started) { c.started = true; c.play(); }
        io.unobserve(e.target);
      });
    }, { threshold: .45 });
    fresh.forEach(function (c) { io.observe(c.node); });
  }
  window.MOMotion = {
    boot: boot,
    modules: modules,
    replayAll: function () { modules.forEach(function (c) { c.done = true; c.play(); }); },
    seekAll: function (t) { modules.forEach(function (c) { c.m.draw(Math.min(t, c.m.dur)); }); },
    setReduced: function (v) { reduced = v; modules.forEach(function (c) { cancelAnimationFrame(c.raf); c.m.draw(v ? c.m.dur : 0); if (!v) c.play(); }); }
  };
  // Auto-boot on the storefront. Deferred scripts (incl. mo-ky-map.js) have run by DOMContentLoaded.
  function auto() { if (!window.MO_EXPORT && !window.MO_NO_AUTOBOOT) boot(); }
  if (document.readyState === 'complete') auto();
  else { document.addEventListener('DOMContentLoaded', auto); window.addEventListener('load', auto); }
  document.addEventListener('shopify:section:load', auto);
})();
